import type { IconProps } from "../../Icon";

import AiChatIcon from "../../../../public/assets/icons/st/ai_chat.svg";
import AiEditIcon from "../../../../public/assets/icons/st/ai_edit.svg";
import AiFormIcon from "../../../../public/assets/icons/st/ai_form.svg";
import AiMicIcon from "../../../../public/assets/icons/st/ai_mic.svg";
import AiSearchIcon from "../../../../public/assets/icons/st/ai_search.svg";

/**
 * AI icon names for `Button` `aiMark`. `"mark"` (or boolean `true`) uses the animated AI mark;
 * other values use static AI icons.
 */
export type AiIconName = "chat" | "edit" | "form" | "mark" | "mic" | "search";

export const AI_ICON_MAP: Record<
  Exclude<AiIconName, "mark">,
  IconProps["svg"]
> = {
  chat: AiChatIcon,
  edit: AiEditIcon,
  form: AiFormIcon,
  mic: AiMicIcon,
  search: AiSearchIcon,
};

export type ButtonAiMarkSize = "xsmall" | "small" | "medium" | "large";

/**
 * Icon-only AI icon container size (px). Medium/large match custom icon-only parity.
 */
export const ICON_ONLY_AI_SIZE_PX: Record<ButtonAiMarkSize, number> = {
  xsmall: 12,
  small: 14,
  medium: 24,
  large: 24,
};

export function iconHasLeadingSlot(
  icon:
    | IconProps["svg"]
    | { before: IconProps["svg"] }
    | { after: IconProps["svg"] }
    | undefined,
): boolean {
  if (!icon) {
    return false;
  }
  if (typeof icon !== "object") {
    return true;
  }
  return "before" in icon;
}

export function aiMarkShowsAnimatedMark(
  aiMark?: boolean | AiIconName,
): boolean {
  return aiMark === true || aiMark === "mark";
}
